// at a minimum, amountOwed, source, and value are required in the trade object
var buildTradeObject = function (tradeData) {
  let paymentDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const tradeInfo = {};
  const {
    icoTradeInOffer
  } = paymentDetails;

  // Values required by DR overlay (SDP)
  if (tradeData.source) {
    tradeInfo.source = tradeData.source;
  }
  if (tradeData.value) {
    tradeInfo.value = Number(tradeData.value);
  }

  /** amountOwed is required field for source as 'ICO and KBB' and not required for 'user'
   *  Passing amountOwed as '0' so it won't break sdp if amountOwed is undefined for any reason.
   */

  // Values not required
  tradeInfo.amountOwed = tradeData.amountOwed >= 0 ? Number(tradeData.amountOwed) : 0;
  if (tradeData?.vin) {
    tradeInfo.vin = tradeData?.vin;
  }
  if (tradeData.make) {
    tradeInfo.make = tradeData.make;
  }
  if (tradeData.model) {
    tradeInfo.model = tradeData.model;
  }
  if (tradeData.trim) {
    tradeInfo.trim = tradeData.trim;
  }
  if (tradeData.year) {
    tradeInfo.year = Number(tradeData.year);
  }
  if (tradeData.mileage) {
    tradeInfo.mileage = Number(tradeData.mileage);
  }
  if (tradeData.status && !!icoTradeInOffer) {
    tradeInfo.status = tradeData.status;
  }
  if (tradeData.condition) {
    tradeInfo.condition = tradeData.condition.toLowerCase();
  }
  return tradeInfo;
};
export { buildTradeObject as default };
